export default function initNews(root = document) {
  const modules = root.matches?.(".sz-news")
    ? [root]
    : root.querySelectorAll(".sz-news");

  console.log("INIT News RUNNING");
  modules.forEach((module) => {
    if (module.dataset.newsInitialised === "true") return;
    module.dataset.newsInitialised = "true";

    const toggle = module.querySelector(".sz-news__toggle");
    const extraItems = module.querySelectorAll(".sz-news__item--extra");
    const bottomMoreLink = module.querySelector(".sz-news__more-link--bottom");

    if (!toggle || !extraItems.length) return;

    toggle.addEventListener("click", () => {
      module.classList.add("sz-news--expanded");
      toggle.setAttribute("aria-expanded", "true");

      extraItems.forEach((item) => {
        item.hidden = false;
      });

      if (bottomMoreLink) {
        bottomMoreLink.hidden = false;
      }

      toggle.remove();
    });
  });
}
